
export default function BlogSearchResults({searchTerm, searchResults, total = null , limit}) {
  return (
    <>
      <div className={"search-results__wrapper"}>
        {searchResults.length > 0 &&
          <ul className="search-results__list">
            {searchResults.slice(0, limit).map((result, index) =>
              <li className={"search-result search-result--" + result.type.system} key={index}>

                <article className={"blog-teaser"}>
                  <div className={"blog-teaser__info"}>
                    <div className={"blog-teaser__content"}>
                      <h3 className={"blog-teaser__title"}>
                        {result.title}
                      </h3>
                      <div className={"blog-teaser__meta"}>
                        <span className="blog-teaser__label">
                          {result.meta.label}
                        </span>
                        <span className="blog-teaser__category">
                          {result.meta.category}
                        </span>
                        <span className={"blog-teaser__read-time"}>
                           <svg className="icon icon-time">
                              <use xlinkHref="#icon-icon-time"></use>
                            </svg>
                          {result.meta.time}
                        </span>
                      </div>
                    </div>
                    <a className={"blog-teaser__link text-link"} href={result.link}>
                    Lees het artikel
                      <svg className="icon icon-mm-link-arrow">
                        <use xlinkHref="#icon-mm-link-arrow"></use>
                      </svg>
                    </a>
                  </div>
                  <div className={"blog-teaser__image"}>
                  <img alt={result.title} src={result.file_url}/>
                  </div>
                </article>


              </li>
            )}
          </ul>
        }
      </div>
    </>
  );
}
